import DOMPurify from "dompurify";

const InnerHtml = ({ classes, unsanitizedData }) => {
    return <div className={classes} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(unsanitizedData) }} />
}

export default InnerHtml;